import { makeStyles } from '@material-ui/core/styles';

import transparentize from '@utils/transparentize';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
  },
  reasonWrapper: {
    marginTop: -107,
    backgroundColor: theme.palette.background.paper,
  },
  blueDot: {
    color: theme.palette.primary.dark,
  },
  topFigures: {
    position: 'relative',
  },
  figureOnTopImageMobile: {
    display: 'none',
    top: 'calc(415px - var(--header-height))',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
  },
  figureOnTopImageOne: {
    width: 283,
    bottom: 107,
    right: 0,
    top: 'unset',
  },
  figureOnTopImageTwo: {
    width: 450,
    bottom: -25,
    left: -46,
    top: 'unset',
  },
  figureOnTopCircleOne: {
    transform: 'translateX(102px)',
    width: 676,
    height: 676,
    position: 'static',
  },
  figureOnTopCircleTwo: {
    width: 135,
    height: 135,
    top: 130,
    left: '-103px',
  },
  figureOnTopCircleThree: {
    top: 382,
    left: 17,
    width: 24,
    height: 24,
  },
  wishes: {
    position: 'relative',
    paddingTop: 56,
  },
  wishesTitle: {
    textAlign: 'left',
    fontSize: 32,
  },
  subtitle: {
    width: '100%',
    margin: '16px 0 24px 0',
  },
  feefoSmall: {
    display: 'flex',
    marginTop: 40,
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  feefoLogo: {
    height: 15,
    marginBottom: 12,
    width: 'auto',
  },
  simpWillTitle: {
    margin: '80px 0 24px',
  },
  gray: {
    color: theme.palette.info.main,
  },
  listLaptopCircle: {
    height: 199,
    width: 199,
    bottom: 0,
    left: 0,
  },
  listLaptopImage: {
    left: 15,
    height: 219,
  },
  listGlassCircle: {
    height: 199,
    width: 199,
    bottom: 0,
    right: 0,
  },
  listGlassImage: {
    right: -50,
    height: 233,
  },
  listNotebookCircle: {
    height: 199,
    width: 199,
    top: 47,
    left: 0,
  },
  listNotebookImage: {
    left: -50,
    height: 244,
  },
  listArrowsCircle: {
    height: 199,
    width: 199,
    top: 50,
    right: 0,
  },
  listArrowsImage: {
    right: 0,
    height: 233,
  },
  icon: {
    marginLeft: 10,
    fontSize: 18,
    verticalAlign: 'middle',
  },
  howCompare: {
    backgroundColor: theme.palette.background.paper,
    padding: '80px 0 40px',
  },
  howCompareTitle: {
    marginBottom: 16,
  },
  estateUpdate: {
    position: 'relative',
    padding: '80px 0 360px',
    '& h6': {
      marginBottom: 24,
    },
    '& $gray': {
      paddingTop: 16,
    },
  },
  startNow: {
    marginTop: 16,
  },
  feature: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 24,
    '& > i': {
      marginRight: 12,
      fontSize: 24,
      color: theme.palette.success.main,
    },
    '&:last-of-type': {
      marginBottom: 40,
    },
  },
  estateUpdateCircleThree: {
    width: 54,
    height: 54,
    top: -22,
    right: 93,
  },
  estateUpdateCircleTwo: {
    width: 24,
    height: 24,
    top: 508,
    left: 3,
  },
  estateUpdateCircleOne: {
    width: 385,
    height: 385,
    top: 368,
    right: -269,
  },
  estateUpdateImageOne: {
    bottom: 80,
    right: -11,
    width: 236,
  },
  description: {
    marginBottom: 40,
    color: theme.palette.info.main,
  },
  relative: {
    position: 'relative',
  },
  textCenter: {
    textAlign: 'center',
  },
  faqWrapper: {
    backgroundColor: theme.palette.background.paper,
    padding: '40px 0 24px',
  },
  faq: {
    flexDirection: 'column',
    position: 'relative',
    '& h3': {
      marginBottom: 16,
    },
  },
  needHelpWrapper: {
    overflow: 'hidden',
    position: 'relative',
    padding: '104px 0 324px',
    '& h3': {
      marginBottom: 24,
    },
  },
  phoneLink: {
    color: theme.palette.secondary.dark,
  },
  needHelpFiguresDesktop: {
    display: 'none',
  },
  needHelpCircleOne: {
    width: 560,
    height: 535,
    top: -490,
    left: '50%',
    transform: 'translateX(-50%)',
  },
  needHelpCircleTwo: {
    width: 288,
    height: 288,
    bottom: -126,
    left: -217,
  },
  needHelpImageOne: {
    width: 268,
    bottom: 0,
    right: 12,
  },
  ensureEstateWrapper: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: 80,
  },
  ensureEstate: {
    paddingBottom: 40,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: transparentize(theme.palette.info.main, 0.3),
  },
  ensureEstateButton: {
    marginTop: 24,
  },
  feefoFooterWrapper: {
    backgroundColor: theme.palette.background.paper,
    padding: '40px 0 80px',
  },
  feefoFooter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  feefoLogoFooter: {
    height: 36,
    marginBottom: 32,
  },
  feefoRatingLabel: {
    marginBottom: 8,
  },
  liveChat: {
    fontSize: 'inherit',
    font: 'inherit',
    fontWeight: 'bold',
    color: theme.palette.secondary.dark,
    textDecoration: 'underline',
  },
  [theme.breakpoints.up('sm')]: {
    topFigures: {
      position: 'absolute',
    },
    wishesTitle: {
      textAlign: 'left',
    },
    listLaptopCircle: {
      height: 300,
      width: 300,
      bottom: 0,
      left: -24,
    },
    listLaptopImage: {
      left: 0,
      top: 0,
      height: 330,
    },
    listGlassCircle: {
      height: 300,
      width: 300,
      bottom: 0,
      left: 'unset',
      right: -24,
    },
    listGlassImage: {
      right: 19,
      bottom: 40,
      height: 330,
    },
    listNotebookCircle: {
      height: 300,
      width: 300,
      bottom: 0,
      left: -24,
      top: 'unset',
    },
    listNotebookImage: {
      left: -73,
      top: 'unset',
      bottom: 0,
      height: 394,
    },
    listArrowsCircle: {
      height: 300,
      width: 300,
      top: 'unset',
      left: 'unset',
      right: -24,
      bottom: 0,
    },
    listArrowsImage: {
      top: 0,
      left: 0,
      height: 373,
    },
    estateUpdate: {
      paddingBottom: 80,
    },
    estateUpdateCircleThree: {
      width: 54,
      height: 54,
      top: -27,
      right: 306,
    },
    estateUpdateCircleTwo: {
      width: 24,
      height: 24,
      top: 'unset',
      bottom: 52,
      left: 266,
    },
    estateUpdateCircleOne: {
      width: 438,
      height: 438,
      top: -50,
      right: -223,
    },
    estateUpdateImageOne: {
      top: 64,
      bottom: 'unset',
      right: 24,
    },
    faq: {
      '& h3': {
        width: 346,
      },
    },
    needHelpWrapper: {
      paddingBottom: 15,
      '& h3': {
        marginBottom: 16,
      },
    },
    needHelp: {
      width: 450,
    },
    needHelpCircleOne: {
      width: 560,
      height: 535,
      top: -490,
      left: '50%',
      transform: 'translateX(-50%)',
    },
    needHelpCircleTwo: {
      display: 'none',
    },
    needHelpImageOne: {
      width: 162,
      right: 39,
    },
    ensureEstateWrapper: {
      paddingTop: 40,
    },
    ensureEstate: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& h6': {
        fontSize: 16,
      },
    },
    ensureEstateButton: {
      marginTop: 0,
    },
    feefoFooterWrapper: {
      paddingBottom: 40,
    },
    feefoFooter: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    feefoLogoFooter: {
      marginRight: 'auto',
      marginBottom: 0,
    },
    feefoRatingLabel: {
      marginBottom: 0,
      marginRight: 16,
    },
    figureOnTopImageOne: {
      width: 273,
      bottom: 0,
      right: 123,
      top: 'unset',
    },
    figureOnTopImageTwo: {
      width: 437,
      bottom: -138,
      right: -175,
      left: 'unset',
      top: 'unset',
    },
    figureOnTopCircleOne: {
      width: 657,
      height: 657,
      top: -11,
      right: -293,
      transform: 'none',
      position: 'absolute',
    },
    figureOnTopCircleTwo: {
      display: 'none',
    },
    figureOnTopCircleThree: {
      width: 212,
      height: 212,
      left: -152,
      top: 'unset',
      bottom: -33,
    },
    wishes: {
      width: 330,
      paddingTop: 40,
      paddingBottom: 43,
    },
    reasonWrapper: {
      marginTop: 0,
    },
    subtitle: {
      width: 'unset',
      margin: '24px 0 40px 0',
    },
    question: {
      paddingBottom: 24,
    },
    readMore: {
      position: 'absolute',
      bottom: 'unset',
      left: 'unset',
      top: 24,
      right: 24,
      cursor: 'pointer',
    },
  },
  [theme.breakpoints.up('md')]: {
    figureOnTopImage: {
      left: 'initial',
      right: '-30px',
      width: 593,
      height: 520,
      top: 0,
    },
    figureOnTopCircleOne: {
      width: 710,
      height: 710,
      top: 'calc(67px - var(--header-height))',
      right: -440,
    },
    figureOnTopCircleThree: {
      display: 'none',
    },
    figureOnTopImageOne: {
      width: 330,
      bottom: 0,
      right: 0,
      top: 'unset',
    },
    figureOnTopImageTwo: {
      width: 555,
      bottom: -165,
      right: -8,
      left: 'unset',
      top: 'unset',
    },
    simpWillTitle: {
      margin: '88px 0 24px',
    },
    listLaptopCircle: {
      height: 318,
      width: 318,
      bottom: 0,
      right: 80,
      left: 'unset',
    },
    listLaptopImage: {
      left: 'unset',
      top: 'unset',
      bottom: 48,
      right: -180,
      height: 350,
    },
    listGlassCircle: {
      height: 318,
      width: 318,
      bottom: 0,
      left: 80,
      right: 'unset',
    },
    listGlassImage: {
      right: 'unset',
      bottom: 'unset',
      left: 0,
      top: 0,
      height: 372,
    },
    listNotebookCircle: {
      height: 318,
      width: 318,
      bottom: 0,
      right: 80,
      left: 'unset',
      top: 'unset',
    },
    listNotebookImage: {
      right: -140,
      left: 'unset',
      bottom: 9,
    },
    listArrowsCircle: {
      height: 318,
      width: 318,
      top: 'unset',
      left: 80,
      right: 'unset',
      bottom: 0,
    },
    listArrowsImage: {
      right: 'unset',
      top: 0,
      left: 0,
      bottom: 'unset',
      height: 373,
    },

    wishes: {
      width: 'unset',
      paddingTop: 98,
      paddingBottom: 111,
    },
    wishesTitle: {
      width: 650,
      fontSize: 48,
      '& br': {
        display: 'none',
      },
    },
    subtitle: {
      width: 410,
    },
    estateUpdateCircleThree: {
      width: 54,
      height: 54,
      top: -18,
      right: 332,
    },
    estateUpdateCircleTwo: {
      width: 24,
      height: 24,
      bottom: 34,
      left: 'unset',
      right: 471,
    },
    estateUpdateCircleOne: {
      width: 543,
      height: 543,
      top: -64,
      right: -314,
    },
    estateUpdateImageOne: {
      bottom: 122,
      width: 296,
      right: -4,
    },
    faq: {
      '& h3': {
        width: 'unset',
      },
    },
    needHelpWrapper: {
      paddingTop: 88,
      paddingBottom: 40,
      '& > div': {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
      },
    },
    needHelp: {
      width: 540,
      '& h3': {
        fontSize: 48,
      },
    },
    needHelpCircleTwo: {
      display: 'block',
      width: 178,
      left: -131,
      bottom: -120,
      height: 178,
    },
    needHelpImageOneDesktop: {
      width: 268,
      top: '-40%',
      right: 0,
    },
    needHelpFiguresDesktop: {
      display: 'block',
      position: 'relative',
    },
    needHelpImageOne: {
      display: 'none',
    },
    ensureEstate: {
      '& h6': {
        fontSize: 24,
      },
    },
    mostPopular: {
      '& h3': {
        marginBottom: 32,
      },
    },
  },
  [theme.breakpoints.up('lg')]: {
    figureOnTopCircleOne: {
      width: 743,
      height: 743,
      top: 'calc(50px - var(--header-height))',
      right: -308,
    },
    figureOnTopCircleThree: {
      width: 24,
      height: 24,
      display: 'block',
      bottom: 65,
      right: 608,
      left: 'unset',
    },
    figureOnTopCircleTwo: {
      width: 181,
      height: 181,
      left: -250,
      display: 'block',
    },
    figureOnTopImageOne: {
      width: 330,
      bottom: 0,
      right: 172,
      top: 'unset',
    },
    figureOnTopImageTwo: {
      width: 555,
      bottom: -167,
      right: -215,
      left: 'unset',
      top: 'unset',
    },
    simpWillTitle: {
      margin: '144px 0 24px',
    },
    wishesTitle: {
      margin: '0 0 40px',
    },
    estateUpdate: {
      paddingBottom: 144,
    },
    estateUpdateCircleThree: {
      top: -16,
      right: 440,
    },
    estateUpdateCircleTwo: {
      bottom: 88,
      right: 640,
    },
    estateUpdateCircleOne: {
      top: -94,
      right: -184,
    },
    faqWrapper: {
      paddingTop: 80,
      '& h3': {
        marginBottom: 32,
      },
    },
    needHelpWrapper: {
      paddingTop: 144,
      paddingBottom: 80,
    },
    needHelpImageOneDesktop: {
      width: 315,
      top: 'unset',
      bottom: -125,
      right: 47,
    },
    needHelpCircleTwo: {
      width: 252,
      left: -163,
      bottom: -142,
      height: 252,
    },
    needHelpCircleOne: {
      height: 560,
    },
    wishes: {
      paddingTop: 126,
    },
  },
}));

export default useStyles;
